import logoEvona from '../../assets/img/evona-logo.png'
import logoAspaec from '../../assets/img/logo-aspaec.png'
import logoBehemp from '../../assets/img/logo-behemp.png'
import logoCanabisil from '../../assets/img/logo-canabisil.png'
import logoCannamazon from '../../assets/img/logo-cannamazon.png'
import logoCannectEntourage from '../../assets/img/logo-cannect-entourage.png'
import logoCannectGreens from '../../assets/img/logo-cannect-greens.png'
import logoCannectNex from '../../assets/img/logo-cannect-nex.png'
import logoCannectRevivid from '../../assets/img/logo-cannect-revivid.png'
import logoCannectUsaHemp from '../../assets/img/logo-cannect-usahemp.png'
import logoCannectVolcanic from '../../assets/img/logo-cannect-volcanic.png'
import logoCannectEliv from '../../assets/img/logo-cannect.png'
import logoCBDUSABrasil from '../../assets/img/logo-cbdusabrasil.png'
import logoClinicVerdeCura from '../../assets/img/logo-clinic-verde-cura.png'
import logoDrConsalter from '../../assets/img/logo-drconsalter.png'
import logoEliv from '../../assets/img/logo-eliv.png'
import logoEntourage from '../../assets/img/logo-entourage.png'
import logoFitoCanabica from '../../assets/img/logo-fito-canabica.png'
import logoGreenLeaf from '../../assets/img/logo-green-leaf.png'
import logoGreens from '../../assets/img/logo-greens.png'
import logoGroen from '../../assets/img/logo-groen.png'
import logoLegalizeHealth from '../../assets/img/logo-legalizehealth.jpg'
import logoNexBiopharma from '../../assets/img/logo-nexbiopharma.png'
import logoNunatureLabs from '../../assets/img/logo-nunaturelabs.png'
import logoRevivid from '../../assets/img/logo-revivid.png'
import logoSalvusCbd from '../../assets/img/logo-salvuscbd.png'
import logoSereneCbd from '../../assets/img/logo-serenecbd.png'
import logoSaude from '../../assets/img/logo.png'
import logoUsaHemp from '../../assets/img/logo-usa-hemp.png'
import logoValtellinamed from '../../assets/img/logo-valtellinamed.jpeg'
import logoMoonlion from '../../assets/img/moonlion-logo.png'
import logoVolcanic from '../../assets/svg/logo-volcanic.svg'
import logoCannafy from '../../assets/img/logo-cannafy.png'
import logoFoliumed from '../../assets/img/logo-foliumed.png'
import logoLumina from '../../assets/img/logo-lumina.png'
import logoVikura from '../../assets/img/logo-vikura.png'
import logoGottapharma from '../../assets/img/logo-gottapharma.png'
import logoAnanmed from '../../assets/img/logo-ananmed.jpg'
import logoEndobalance from '../../assets/img/logo-endobalance.png'

export const themes = {
  eliv: {
    colors: {
      primary: '#008AAD',
      secondary: '#3D3D3D',
      tertiary: '#008AAD',
      quartiary: '#3D3D3D',
      primaryLight: '#E0E7EC',
      menu: '#E4E9F2',
      inputBg: '#E4E9F2',
      hover: 'rgba(39, 154, 172, 0.2);',
      login: '#ffffff',
      loginBtn: '#008AAD',
    },
    logo: logoEliv,
    logoCannect: logoCannectEliv,
  },
  usahemp: {
    colors: {
      primary: '#6BA543',
      secondary: '#F6F6F6',
      tertiary: '#D8AB27',
      quartiary: '#F0780A',
      primaryLight: '#F6F6F6',
      menu: '#6BA543',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#6BA543',
    },
    logo: logoUsaHemp,
    logoCannect: logoCannectUsaHemp,
  },
  revivid: {
    colors: {
      primary: '#173231',
      secondary: '#81C04C',
      tertiary: '#81C04C',
      quartiary: '#F0780A',
      primaryLight: '#F6F6F6',
      menu: '#173231',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#173231',
    },
    logo: logoRevivid,
    logoCannect: logoCannectRevivid,
  },
  volcanic: {
    colors: {
      primary: '#9ABEAA',
      secondary: '#6DAD52',
      tertiary: '#173231',
      quartiary: '#F0780A',
      primaryLight: '#F6F6F6',
      menu: '#9ABEAA',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#9ABEAA',
    },
    logo: logoVolcanic,
    logoCannect: logoCannectVolcanic,
  },
  moonlion: {
    colors: {
      primary: '#00B3EA',
      secondary: '#00B3EA',
      tertiary: '#00B3EA',
      quartiary: '#F0780A',
      primaryLight: '#F6F6F6',
      menu: '#FFFFFF',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#E3E3E3',
      loginBtn: '#1B4BA4',
    },
    logo: logoMoonlion,
    logoCannect: logoCannectUsaHemp,
  },
  valtellinamed: {
    colors: {
      primary: '#565656',
      secondary: '#333333',
      tertiary: '#565656',
      quartiary: '#333333',
      primaryLight: '#F6F6F6',
      menu: '#FFFFFF',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#E3E3E3',
      loginBtn: '#1B4BA4',
    },
    logo: logoValtellinamed,
    logoCannect: logoCannectVolcanic,
  },
  evona: {
    colors: {
      primary: '#51312D',
      secondary: '#EF8903',
      tertiary: '#51312D',
      quartiary: '#333333',
      primaryLight: '#F6F6F6',
      menu: '#FFFFFF',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#E3E3E3',
      loginBtn: '#1B4BA4',
    },
    logo: logoEvona,
    logoCannect: logoCannectVolcanic,
  },
  nunaturelabs: {
    colors: {
      primary: '#78C242',
      secondary: '#5694FF',
      tertiary: '#78C242',
      quartiary: '#78C242',
      primaryLight: '#78C242',
      menu: '#FFFFFF',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#E3E3E3',
      loginBtn: '#1B4BA4',
    },
    logo: logoNunatureLabs,
    logoCannect: logoCannectVolcanic,
  },
  behemp: {
    colors: {
      primary: '#78C242',
      secondary: '#5694FF',
      tertiary: '#78C242',
      quartiary: '#78C242',
      primaryLight: '#78C242',
      menu: '#FFFFFF',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#E3E3E3',
      loginBtn: '#1B4BA4',
    },
    logo: logoBehemp,
    logoCannect: logoCannectVolcanic,
  },
  serene: {
    colors: {
      primary: '#008AAD',
      secondary: '#E4E9F2',
      tertiary: '#008AAD',
      quartiary: '#008AAD',
      primaryLight: '#78C242',
      menu: '#FFFFFF',
      inputBg: '#008AAD',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#E3E3E3',
      loginBtn: '#1B4BA4',
    },
    logo: logoSereneCbd,
    logoCannect: logoCannectEliv,
  },
  nexbiopharma: {
    colors: {
      primary: '#6A62E5',
      secondary: '#211F20',
      tertiary: '#6A62E5',
      quartiary: '#211F20',
      primaryLight: '#211F20',
      menu: '#FFFFFF',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#E3E3E3',
      loginBtn: '#1B4BA4',
    },
    logo: logoNexBiopharma,
    logoCannect: logoCannectNex,
  },
  entourage: {
    colors: {
      primary: '#0091A3',
      secondary: '#093D5B',
      tertiary: '#6A62E5',
      quartiary: '#211F20',
      primaryLight: '#211F20',
      menu: '#FFFFFF',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#E3E3E3',
      loginBtn: '#1B4BA4',
    },
    logo: logoEntourage,
    logoCannect: logoCannectEntourage,
  },
  greens: {
    colors: {
      primary: '#4DB160',
      secondary: '#009F41',
      tertiary: '#6A62E5',
      quartiary: '#211F20',
      primaryLight: '#211F20',
      menu: '#FFFFFF',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#E3E3E3',
      loginBtn: '#1B4BA4',
    },
    logo: logoGreens,
    logoCannect: logoCannectGreens,
  },
  canabisil: {
    colors: {
      primary: '#425f32',
      secondary: '#F6F6F6',
      tertiary: '#D8AB27',
      quartiary: '#F0780A',
      primaryLight: '#F6F6F6',
      menu: '#425f32',
      inputBg: '#F3F3F3',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#425f32',
    },
    logo: logoCanabisil,
    logoCannect: logoCannectUsaHemp,
  },
  fitocanabica: {
    colors: {
      primary: '#29424A',
      secondary: '#93ABA5',
      tertiary: '#D8AB27',
      quartiary: '#F0780A',
      primaryLight: '#EEEEEE',
      menu: '#29424A',
      inputBg: '#93ABA5',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#29424A',
    },
    logo: logoFitoCanabica,
    logoCannect: logoCannectUsaHemp,
  },
  greenleaf: {
    colors: {
      primary: '#009900',
      secondary: '#000000',
      tertiary: '#009900',
      quartiary: '#F0780A',
      primaryLight: '#EEEEEE',
      menu: '#000000',
      inputBg: '#000000',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#29424A',
    },
    logo: logoGreenLeaf,
    logoCannect: logoCannectUsaHemp,
  },
  salvuscbd: {
    colors: {
      primary: '#235f3d',
      secondary: '#4a909c',
      tertiary: '#235f3d',
      quartiary: '#4a909c',
      primaryLight: '#235f3d',
      menu: '#235f3d',
      inputBg: '#235f3d',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#29424A',
    },
    logo: logoSalvusCbd,
    logoCannect: logoCannectUsaHemp,
  },
  cbdusabrasil: {
    colors: {
      primary: '#6e9052',
      secondary: '#f8ab4f',
      tertiary: '#765aa5',
      quartiary: '#6e9052',
      primaryLight: '#6e9052',
      menu: '#ffffff',
      inputBg: '#6e9052',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#29424A',
    },
    logo: logoCBDUSABrasil,
    logoCannect: logoCannectUsaHemp,
  },
  clinicverdecura: {
    colors: {
      primary: '#64b227',
      secondary: '#1c2f0c',
      tertiary: '#ffffff',
      quartiary: '#64b227',
      primaryLight: '#64b227',
      menu: '#ffffff',
      inputBg: '#6e9052',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#29424A',
    },
    logo: logoClinicVerdeCura,
    logoCannect: logoCannectUsaHemp,
  },
  cannamazon: {
    colors: {
      primary: '#f3fbe3',
      secondary: '#47a90d',
      tertiary: '#abdc88',
      quartiary: '#84ac74',
      primaryLight: '#94b480',
      menu: '#ffffff',
      inputBg: '#6e9052',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#29424A',
    },
    logo: logoCannamazon,
    logoCannect: logoCannectUsaHemp,
  },
  groen: {
    colors: {
      primary: '#246b2e',
      secondary: '#47a90d',
      tertiary: '#246b2e',
      quartiary: '#84ac74',
      primaryLight: '#94b480',
      menu: '#673ab7',
      inputBg: '#6e9052',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#29424A',
    },
    logo: logoGroen,
    logoCannect: logoCannectUsaHemp,
  },
  legalizehealth: {
    colors: {
      primary: '#2C4329',
      secondary: '#FFFEFF',
      tertiary: '#abdc88',
      quartiary: '#84ac74',
      primaryLight: '#94b480',
      menu: '#ffffff',
      inputBg: '#6e9052',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#29424A',
    },
    logo: logoLegalizeHealth,
    logoCannect: logoCannectUsaHemp,
  },
  drconsalter: {
    colors: {
      primary: '#9483FF',
      secondary: '##FFFFFF',
      tertiary: '##FFFFFF',
      quartiary: '#9483FF',
      primaryLight: '#9C8FEB',
      menu: '#9483FF',
      inputBg: '#9483FF',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#9483FF',
    },
    logo: logoDrConsalter,
    logoCannect: logoCannectUsaHemp,
  },
  aspaec: {
    colors: {
      primary: '#02b0bb',
      secondary: '#000000',
      tertiary: '#02b0bb',
      quartiary: '#02b0bb',
      primaryLight: '#000000',
      menu: '#02b0bb',
      inputBg: '#000000',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#000000',
    },
    logo: logoAspaec,
    logoCannect: logoCannectUsaHemp,
  },
  saude: {
    colors: {
      primary: '#7E8746',
      secondary: '#2F3440',
      tertiary: '#D7DAB8',
      quartiary: '#ECE9E1',
      primaryLight: '#F6F6F4',
      menu: '#7E8746',
      inputBg: '#ECE9E1',
      hover: 'rgba(126, 135, 70, 0.15)',
      login: '#FFFFFF',
      loginBtn: '#7E8746',
    },
    logo: logoSaude,
    logoCannect: logoCannectUsaHemp,
  },
  cannafy: {
    colors: {
      primary: '#0f766e',
      secondary: '#0f766e',
      tertiary: '#0f766e',
      quartiary: '#ffffff',
      primaryLight: '#0f766e',
      inputBg: '#0f766e',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#0f766e',
    },
    logo: logoCannafy,
    logoCannect: logoCannectUsaHemp,
  },
  foliumed: {
    colors: {
      primary: '#C43C3E',
      secondary: '#C43C3E',
      tertiary: '#C43C3E',
      quartiary: '#ffffff',
      primaryLight: '#0f766e',
      inputBg: '#0f766e',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#0f766e',
    },
    logo: logoFoliumed,
    logoCannect: logoCannectUsaHemp,
  },
  lumina: {
    colors: {
      primary: '#9b8a87',
      secondary: '#9b8a87',
      tertiary: '#9b8a87',
      quartiary: '#ffffff',
      primaryLight: '#000000',
      inputBg: '#000000',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#ffffff',
      loginBtn: '#000000',
    },
    logo: logoLumina,
    logoCannect: logoCannectUsaHemp,
  },
  vikura: {
    colors: {
      primary: '#FC5E3B',
      secondary: '#FC5E3B',
      tertiary: '#FC5E3B',
      quartiary: '#FC5E3B',
    },
    logo: logoVikura,
    logoCannect: logoCannectUsaHemp,
  },
  gottapharma: {
    colors: {
      primary: '#0676BD',
      secondary: '#0676BD',
      tertiary: '#0676BD',
      quartiary: '#0676BD',
      primaryLight: '#0676BD',
      inputBg: '#0676BD',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#0676BD',
      loginBtn: '#000000',
    },
    logo: logoGottapharma,
    logoCannect: logoCannectUsaHemp,
  },
  ananmed: {
    colors: {
      primary: '#06210F',
      secondary: '#06210F',
      tertiary: '#06210F',
      quartiary: '#06210F',
      primaryLight: '#06210F',
      inputBg: '#06210F',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#06210F',
      loginBtn: '#000000',
    },
    logo: logoAnanmed,
    logoCannect: logoCannectUsaHemp,
  },
  endobalance: {
    colors: {
      primary: '#0B5F89',
      secondary: '#0B5F89',
      tertiary: '#0B5F89',
      quartiary: '#0B5F89',
      primaryLight: '#0B5F89',
      inputBg: '#0B5F89',
      hover: 'rgba(91, 148, 91, 0.2);',
      login: '#0B5F89',
      loginBtn: '#000000',
    },
    logo: logoEndobalance,
    logoCannect: logoCannectUsaHemp,
  },
}
